// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  local: false,
  environment: 'Dev',
  cognitoAppClientId: '27bf1c2bcjdrn76s8i73od0ahd',
  cognitoUserPoolId: 'us-east-1_6EfpG1KAx',
  backendUrl: 'https://api.dev.notifitoken.tokenlab.dev/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
